import { useMutation, useQuery, useQueryClient } from "react-query";
import { checklistsApi } from "@/react/api/checklistsApi";

export const useChecklistApi = () => {
  const queryClient = useQueryClient();
  const queryKey = ["checklists", "show"];

  const {
    data: checklist,
    isLoading: isChecklistLoading,
    error: errorFetchingChecklist,
  } = useQuery({
    queryKey,
    queryFn: checklistsApi.show,
  });

  const updateChecklistMutation = useMutation({
    mutationFn: checklistsApi.update,
    onSuccess: updatedChecklist => {
      queryClient.setQueryData(queryKey, updatedChecklist);
    },
  });

  const fetchBroadcastMutation = useMutation({
    mutationFn: checklistsApi.broadcast,
  });

  const fetchDefaultAccessGroupMutation = useMutation({
    mutationFn: checklistsApi.defaultAccessGroup,
  });

  return {
    checklist,
    isChecklistLoading,
    errorFetchingChecklist,
    fetchDefaultAccessGroup: fetchDefaultAccessGroupMutation.mutate,
    isFetchingDefaultAccessGroup: fetchDefaultAccessGroupMutation.isLoading,
    fetchDefaultAccessGroupError: fetchDefaultAccessGroupMutation.error,
    updateChecklist: updateChecklistMutation.mutate,
    isUpdatingChecklist: updateChecklistMutation.isLoading,
    updateChecklistError: updateChecklistMutation.error,
    fetchBroadcast: fetchBroadcastMutation.mutate,
    isFetchingBroadcast: fetchBroadcastMutation.isLoading,
    fetchBroadcastError: fetchBroadcastMutation.error,
  };
};
